import { createContext, useEffect, useState } from "react";
import axios from "axios";
const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;

export const Context = createContext(null);

const ContextProvider = (props) => {
  const url = BACKEND_URL;
  const [token, setToken] = useState("");

  useEffect(() => {
    async function loadData() {
      const storedToken = localStorage.getItem("token");
      if (storedToken) {
        setToken(storedToken); // Set the token from localStorage
      }
    }
    loadData();
  }, []); // Empty dependency array

  const contextValue = {
    url,
    token,
    setToken,
  };

  return (
    <Context.Provider value={contextValue}>{props.children}</Context.Provider>
  );
};

export default ContextProvider;
